import React from "react";
import { List, Datagrid, TextField, NumberField, DateField, FunctionField } from "react-admin";

const notesPreview = (record: any) => {
  const text: string = record?.notesPt || "";
  const firstLine = text.split("\n").find((l) => l.trim().length > 0) || "";
  return firstLine.length > 80 ? `${firstLine.slice(0, 80)}…` : firstLine;
};

const AppReleasesList = () => (
  <List
    sort={{ field: "createdAt", order: "DESC" }}
    perPage={25}
    title="Versões do app"
    exporter={false}
  >
    <Datagrid rowClick="show">
      <TextField source="version" label="Versão" />
      <NumberField source="build" label="Build" />
      <DateField source="releaseDate" label="Lançamento" />
      <FunctionField label="Notas" render={notesPreview} />
    </Datagrid>
  </List>
);

export default AppReleasesList;
